module.exports = __webpack_public_path__ + "static/media/country_li.7d6e901d.webp";